'use strict';
import categoryCommon from "./categoryCommon";

/**
 * Everything specific to the category branch layout.
 * @namespace
 */
var responsiveCatBranch = {
	/**
	 * Initialize the product list.
	 * @returns {undefined}
	 */
	init: function() {
		// Register the event tracking first.
		categoryCommon.init();
		this.eventTracking();

		this.bottomPanelCollapse();

		this.initToggleSellersHeader();
		this.initSubcatViewToggle();
		this.initSubcatDragScroll();
		this.initSubcatResizeHandler();

		if ($('.productRow').length > 0) {
			$('.adBannerAfterTenthProduct').insertAfter('.productRow:nth-child(11)');
		}
	},
	/**
	 * Controls the behavior of the sticky bottom slide-up panel on phones.
	 * @returns {undefined}
	 */
	bottomPanelCollapse: function() {
		let triggerCollapse = $('.triggerCollapse');

		if (triggerCollapse.length) {
			let openPanel = $('#open-panel'),
				mainNavWrapHeight = $('#main-navigation-wrapper').innerHeight(),
				scale = Math.min(
					(window.innerHeight - mainNavWrapHeight - $('.bottomContentPanel.whyShopSonic').innerHeight()) / openPanel.innerHeight(),
					1
				),
				shift = (((1 - scale) * 100) / 2),
				openPanelOffsetTop = openPanel.offset().top;

			openPanel.css({
				transform: "translate(" + shift + "%, " + shift + "%) " + "scale(" + scale + ")"
			});

			$(document.body).on('shown.bs.collapse', '#open-panel .card div', function() {
				let element = this,
					bottomContentSwipeHeight = 60,
					top = 0;

				do {
					top += element.offsetTop || 0;
					element = element.offsetParent;
				} while(element);

				$(this).closest('.panel-container').animate({
					scrollTop: top - mainNavWrapHeight- bottomContentSwipeHeight
				}, 'slow');
			});

			if ($('.bottomPanel').hasClass('iosDevice')) {
				triggerCollapse.click(function() {
					triggerCollapse.toggleClass('active');
					if (triggerCollapse.hasClass('active')) {
						$('#open-panel').addClass('open').slideDown(400);
						sonicGlobal.overlayActivate();
					} else {
						$('#open-panel').slideUp(400).removeClass('open');
						sonicGlobal.overlayDeactivate();
					}
				});
			} else {
				// Enable swiping...
				let bottomContentSwipe = $('.bottomContentSwipe');

				if (bottomContentSwipe.length > 0) {
					bottomContentSwipe.swipe( {
						swipeDown: function() {
							triggerCollapse.removeClass('active open');
							$('#open-panel').slideUp(400);
							sonicGlobal.overlayDeactivate();
						},
						swipeUp: function() {
							triggerCollapse.addClass('active open');
							$('#open-panel').slideDown(400);
							sonicGlobal.overlayActivate();
						},
						tap: function() {
							triggerCollapse.toggleClass('active');
							if (triggerCollapse.hasClass('active')) {
								$('#open-panel').addClass('open').slideDown(400);
								sonicGlobal.overlayActivate();
							} else {
								$('#open-panel').slideUp(400).removeClass('open');
								sonicGlobal.overlayDeactivate();
							}
						},
						threshold: 20,
						triggerOnTouchLeave: "true"
					});
				}
			}
		}
	},
	/**
	 * Category branch page event tracking.
	 * @returns {undefined}
	 */
	eventTracking: function() {
		$(document.body).on('click', '.subCategoryContainer.innerContainer a', function() {
			let subCategoryLinkEventLabel = $(this).data('eventLabel').replaceAll('"', '-inch');

			ga('send', 'event', 'Category', 'Subcat Thumb', subCategoryLinkEventLabel);
		});
	},
	/**
	 * Initializes the subcategory view toggle (slider vs grid).
	 * The inline head script in viewBranch.php already set html.view-slider (or not)
	 * before first paint, so we only need to sync aria-pressed and wire dots on init.
	 * NOTE: The body click handler on .subcatViewBtn is never removed. Safe for now because
	 * category pages do full reloads on navigation. If this page ever goes
	 * partial-page-update (AJAX), add a matching .off('click', '.subcatViewBtn') on teardown.
	 * @returns {undefined}
	 */
	initSubcatViewToggle: function() {
		if ($('.subcatSliderSection').length < 1) {
			return;
		}

		// Sync aria-pressed and build dots to match whatever mode the head script chose.
		if (document.documentElement.classList.contains('view-slider')) {
			this.initAllSubcatSliderDots(true);
			$('.subcatViewBtnSlider').attr('aria-pressed', 'true');
		}
		else {
			$('.subcatViewBtnGrid').attr('aria-pressed', 'true');
		}

		if ($('.subcatViewToggle').length < 1) {
			return;
		}

		$(document.body).on('click', '.subcatViewBtn', function() {
			let mode = $(this).hasClass('subcatViewBtnSlider') ? 'slider' : 'grid';
			responsiveCatBranch.applySubcatViewMode(mode);
			responsiveCatBranch.setSubcatViewCookie(mode);
			try { ga('send', 'event', 'Category', 'Subcategory View Toggle', mode); } catch (e) {}
		});
	},
	/**
	 * Applies slider or grid mode by toggling html.view-slider.
	 * Active button styling is derived from that class via CSS in _subcat-critical.scss.
	 * @param {string} mode - 'slider' or 'grid'
	 * @returns {undefined}
	 */
	applySubcatViewMode: function(mode) {
		if (mode !== 'slider' && mode !== 'grid') {
			return;
		}

		let isSlider = mode === 'slider';
		document.documentElement.classList.toggle('view-slider', isSlider);
		$('.subcatViewBtnSlider').attr('aria-pressed', isSlider ? 'true' : 'false');
		$('.subcatViewBtnGrid').attr('aria-pressed', isSlider ? 'false' : 'true');

		if (isSlider) {
			this.initAllSubcatSliderDots(true);
		}
		else {
			$('.subcatSliderSection .arrowLeft, .subcatSliderSection .arrowRight').hide();
			// Clear any in-progress drag state so a mid-drag mode switch doesn't suppress
			// the next click when the user re-enters slider mode.
			$('.subcatSliderWrapper').data('isDragging', false);
		}
	},
	/**
	 * Reads the subcategory view mode cookie.
	 * NOTE: Not called by this file — cookie reading on page load is handled by the inline
	 * head script in viewBranch.php (which sets html.view-slider before first paint).
	 * Retained here in case a future caller needs it outside the load path.
	 * @returns {string|null}
	 */
	getSubcatViewCookie: function() {
		let cookieName = $('#shopByCategory').data('cookieName');
		let safeName = cookieName.replace(/[.*+?^${}()|[\]\\]/g, '\\$&');
		let match = document.cookie.match(new RegExp('(?:^|;\\s*)' + safeName + '=([^;]+)'));
		return match ? match[1] : null;
	},
	/**
	 * Writes the subcategory view mode cookie (1-year expiry).
	 * @param {string} mode - 'slider' or 'grid'
	 * @returns {undefined}
	 */
	setSubcatViewCookie: function(mode) {
		let expires = new Date();
		expires.setFullYear(expires.getFullYear() + 1);
		// Secure flag: intentional — prod is always HTTPS. On local HTTP dev the cookie
		// is silently dropped by the browser, so the preference resets on each page load.
		let cookieName = $('#shopByCategory').data('cookieName');
		document.cookie = cookieName + '=' + mode + '; path=/; expires=' + expires.toUTCString() + '; SameSite=Lax; Secure';
	},
	/**
	 * Initializes slider dots for all subcategory slider wrappers.
	 * @param {boolean} isFirstInit - TRUE resets scroll to 0; FALSE preserves current position (resize).
	 * @returns {undefined}
	 */
	initAllSubcatSliderDots: function(isFirstInit) {
		$('.subcatSliderWrapper').each(function() {
			responsiveCatBranch.initSubcatSlider(this, isFirstInit);
		});
	},
	/**
	 * Builds dots, wires scroll-indicator dots, and manages </>  nav arrows for a single slider.
	 * Custom implementation rather than global.js customSlider: global handles basic arrows only and
	 * lacks the slider/grid toggle, per-page dots, cookie persistence, and drag-to-scroll this feature needs.
	 * @param {Element} wrapper - The .subcatSliderWrapper element
	 * @param {boolean} isFirstInit - TRUE resets scroll to 0; FALSE preserves current position (resize).
	 * @returns {undefined}
	 */
	initSubcatSlider: function(wrapper, isFirstInit) {
		let $wrapper = $(wrapper);
		let $positionParent = $wrapper.parent();
		let $section = $wrapper.find('.subCategorySection');
		let $dotsContainer = $positionParent.next('.subcatSliderDots');
		let $arrowRight = $positionParent.find('.arrowRight');
		let $arrowLeft = $positionParent.find('.arrowLeft');

		let scrollDuration = 800;

		let $cards = $section.find('> .subCategoryContainer');
		let cardCount = $cards.length;
		let cardWidth = $cards.first().outerWidth(true);
		let visibleCount = cardWidth > 0 ? Math.max(1, Math.floor(wrapper.clientWidth / cardWidth)) : 1;
		let pageCount = cardCount > 0 ? Math.ceil(cardCount / visibleCount) : 0;
		let pageWidth = cardWidth * visibleCount;

		// One dot per visible page; always clear first so stale dots from a prior
		// narrow→wide resize (pageCount < 2) are removed before rebuilding.
		if ($dotsContainer.length) {
			$dotsContainer.empty();

			if (pageCount >= 2) {
				for (let i = 0; i < pageCount; i++) {
					$('<button type="button" class="subcatDot" aria-label="Go to slide ' + (i + 1) + '"></button>').data('index', i).appendTo($dotsContainer);
				}
				// Remove inline display override so the SCSS (html.view-slider parent) controls visibility.
				$dotsContainer.css('display', '');
			} else {
				// No pages to navigate; suppress the container's padding by hiding it explicitly.
				$dotsContainer.css('display', 'none');
			}
		}

		let updateUI = function() {
			let scrollLeft = $wrapper.scrollLeft();
			let maxScroll = wrapper.scrollWidth - wrapper.clientWidth;

			// Dots
			if ($dotsContainer.length && pageCount >= 2) {
				let activeIndex = pageWidth > 0
					? (scrollLeft >= maxScroll - 5 ? pageCount - 1 : Math.round(scrollLeft / pageWidth))
					: 0;
				$dotsContainer.find('.subcatDot').removeClass('active').attr('aria-current', 'false').eq(activeIndex).addClass('active').attr('aria-current', 'true');
			}

			// Arrows — desktop only; mobile uses native touch scroll
			if (typeof window.sonicGlobal !== 'undefined' && !window.sonicGlobal.isMobile) {
				scrollLeft > 5 ? $arrowLeft.show() : $arrowLeft.hide();
				scrollLeft < maxScroll - 5 ? $arrowRight.show() : $arrowRight.hide();
			}

			// Mobile edge fades — CSS (.subcat-fade-left/right) scopes them to phoneMax
			$positionParent.toggleClass('subcat-fade-left', scrollLeft > 5);
			$positionParent.toggleClass('subcat-fade-right', scrollLeft < maxScroll - 5);
		};

		requestAnimationFrame(function() {
			if (isFirstInit) {
				// On first init: reset to page 1 — scroll-snap can snap to a non-zero position before
				// we read it, falsely showing the left arrow. Mirror global.js customSlider behavior.
				wrapper.scrollLeft = 0;
				if ($dotsContainer.length && pageCount >= 2) {
					$dotsContainer.find('.subcatDot').removeClass('active').attr('aria-current', 'false').eq(0).addClass('active').attr('aria-current', 'true');
				}
				if (typeof window.sonicGlobal !== 'undefined' && !window.sonicGlobal.isMobile) {
					$arrowLeft.hide();
					wrapper.scrollWidth > wrapper.clientWidth ? $arrowRight.show() : $arrowRight.hide();
				}

				// Mobile edge fades — left hidden at start, right shown only if content overflows
				$positionParent.removeClass('subcat-fade-left');
				$positionParent.toggleClass('subcat-fade-right', wrapper.scrollWidth > wrapper.clientWidth);
			}
			else {
				// On resize: recompute dots/arrows from the preserved scroll position.
				updateUI();
			}
		});

		$wrapper.off('scroll.subcatSlider').on('scroll.subcatSlider', updateUI);

		// Dot clicks — jump to that page
		$dotsContainer.off('click.subcatDot').on('click.subcatDot', '.subcatDot', function() {
			let index = $(this).data('index');
			let target = (index === pageCount - 1)
				? wrapper.scrollWidth - wrapper.clientWidth
				: index * pageWidth;
			$wrapper.stop().animate({ scrollLeft: target }, scrollDuration);
		});

		// Arrow clicks — desktop only
		if (typeof window.sonicGlobal !== 'undefined' && !window.sonicGlobal.isMobile) {
			$arrowRight.off('click.subcatArrow').on('click.subcatArrow', function() {
				$wrapper.stop().animate({ scrollLeft: $wrapper.scrollLeft() + pageWidth }, scrollDuration);
			});

			$arrowLeft.off('click.subcatArrow').on('click.subcatArrow', function() {
				$wrapper.stop().animate({ scrollLeft: $wrapper.scrollLeft() - pageWidth }, scrollDuration);
			});
		}
	},
	/**
	 * Enables mouse drag-to-scroll on subcategory slider wrappers.
	 * Prevents link clicks from firing after a drag.
	 * NOTE: The body mousedown/mousemove/mouseup/mouseleave/click handlers are never removed.
	 * Safe for now because category pages do full reloads on navigation. If this page ever goes
	 * partial-page-update (AJAX), add matching .off() calls on teardown.
	 * @returns {undefined}
	 */
	initSubcatDragScroll: function() {
		if (!$('.subcatSliderWrapper').length) {
			return;
		}
		$(document.body)
			.on('mousedown', '.subcatSliderWrapper', function(e) {
				$(this).data({
					'dragActive': true,
					'isDragging': false,
					'dragStartX': e.pageX - this.offsetLeft,
					'dragScrollLeft': $(this).scrollLeft()
				}).css('cursor', 'grabbing');
			})
			.on('mousemove', '.subcatSliderWrapper', function(e) {
				let $this = $(this);
				if (!$this.data('dragActive')) {
					return;
				}
				e.preventDefault();
				let x = e.pageX - this.offsetLeft;
				let walk = x - $this.data('dragStartX');
				if (Math.abs(walk) > 5) {
					$this.data('isDragging', true);
				}
				this.scrollLeft = $this.data('dragScrollLeft') - walk;
			})
			.on('mouseup mouseleave', '.subcatSliderWrapper', function() {
				// dragActive is cleared but isDragging is intentionally left as-is.
				// Every real mouse click starts with mousedown, which resets isDragging=false,
				// so isDragging=true here never reaches the click handler for normal interactions.
				// Clearing isDragging on mouseup would create a race: the click event fires
				// synchronously after mouseup and would no longer be suppressed post-drag.
				$(this).data('dragActive', false).css('cursor', '');
			})
			.on('click', '.subcatSliderWrapper a', function(e) {
				let $wrapper = $(this).closest('.subcatSliderWrapper');
				if ($wrapper.data('isDragging')) {
					e.preventDefault();
					e.stopPropagation();
					$wrapper.data('isDragging', false);
				}
			});
	},
	/**
	 * Re-initializes all subcategory sliders on window resize (debounced).
	 * Recomputes dots, arrows, and page dimensions when the viewport changes.
	 * NOTE: The resize.subcatSlider handler is never removed. Safe for now because
	 * category pages do full reloads on navigation. If this page ever goes
	 * partial-page-update (AJAX), add a matching .off('resize.subcatSlider') on teardown.
	 * @returns {undefined}
	 */
	initSubcatResizeHandler: function() {
		if (!$('#shopByCategory').length) {
			return;
		}
		let resizeTimer;
		$(window).on('resize.subcatSlider', function() {
			clearTimeout(resizeTimer);
			resizeTimer = setTimeout(function() {
				if (document.documentElement.classList.contains('view-slider')) {
					responsiveCatBranch.initAllSubcatSliderDots(false);
				}
			}, 250);
		});
	},
	/**
	 * Initializes the toggle Seller header section.
	 * If an ajax request is made through the guidedbrowsing, and a filter is selected,
	 * this section will be hidden. Otherwise display it.
	 * @returns {undefined}
	 */
	initToggleSellersHeader: function() {
		let tsContElem = $('#tsContainer');

		if (tsContElem.length < 1) {
			return;
		}

		$(document).on("ajaxComplete", function(event, xhr, settings) {
			if ($('#filter-menu-right .guided-browsing-checkbox:checked').length > 0) {
				tsContElem.addClass('d-none');
			} else {
				tsContElem.removeClass('d-none');
			}
		});
	}
};

// DOM ready
$(function() {
	responsiveCatBranch.init();
});
